import { computeTotal } from './format.js';
import { inputFields, fieldValue } from './validate.js';
/**
 * Collected field values, keyed by `FieldConfig.key`. Trimmed, matching the original.
 *
 * `prefix_text` is PREPENDED, exactly as the legacy `read()` did (`form.ts:170`). The prefix is
 * displayed inside the input but never typed by the buyer, so without this a merchant using a dial
 * code as a prefix would receive phone numbers with the country code missing.
 */
export function collectFields(config, state) {
    const fields = {};
    for (const field of inputFields(config)) {
        const value = fieldValue(state, field.key);
        fields[field.key] = field.prefix_text && value ? `${field.prefix_text}${value}` : value;
    }
    return fields;
}
export function buildSubmission(config, ctx, state, opts = {}) {
    const quantity = Math.max(1, state.quantity);
    const lineTotal = opts.lineTotal ?? computeTotal({ ...ctx, quantity });
    // Only positive, finite ids — the original filtered these before submitting (`form.ts:1322`).
    const variantIds = (opts.offerVariantIds ?? []).filter((n) => Number.isFinite(n) && n > 0);
    return {
        product: {
            id: ctx.product.id,
            variant_id: ctx.variant.id,
            quantity,
            // Effective per-unit price as a fixed-2 STRING, not a number. The backend resolves prices
            // server-side but reads this shape; changing the type is a contract change.
            price: (lineTotal / quantity).toFixed(2),
        },
        fields: collectFields(config, state),
        // `undefined`, never `''` — an empty string would be sent as a real (invalid) coupon code.
        discount_code: state.discountCode.trim() || undefined,
        // Carry the offer + tier so the backend recomputes the discount, plus per-unit variant ids so
        // it can split the order line. Spread-omitted rather than set to undefined, matching the
        // original's conditional-spread so the key is genuinely absent.
        ...(opts.offerId && state.selectedTierId
            ? {
                offer: {
                    offer_id: opts.offerId,
                    tier_id: state.selectedTierId,
                    ...(variantIds.length ? { variant_ids: variantIds } : {}),
                },
            }
            : {}),
        shipping: opts.shippingRate
            ? {
                rate_id: opts.shippingRate.id,
                name: opts.shippingRate.name,
                cost: opts.shippingRate.price,
            }
            : undefined,
        ...(opts.removedVariantIds?.length ? { removedVariantIds: [...opts.removedVariantIds] } : {}),
        ...(opts.items?.length ? { items: [...opts.items] } : {}),
        consent: {
            newsletter: state.values['__newsletter'] === 'true',
            terms: state.values['__terms'] === 'true',
        },
        meta: {
            currency: ctx.currency,
            ...(ctx.locale ? { lang: ctx.locale } : {}),
        },
    };
}
//# sourceMappingURL=collect.js.map